/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Quikipay
 */
export class Quikipay {
    /**
     *
     * @type {string}
     * @memberof Quikipay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Quikipay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Quikipay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Quikipay
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Quikipay
     */
    apiKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Quikipay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Quikipay
     */
    autoApprove: boolean;
}
